import React, { PureComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import Big from 'big.js';
import { QuantityFormField } from 'components';

import { Grid, IconButton, Typography } from '@material-ui/core';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons/';
import { WithStyles, withStyles } from '@material-ui/styles';

import styles from './QuantityPanel.style';

interface QuantityPanelProps
  extends WithTranslation,
    WithStyles<typeof styles> {
  quantity: number;
  price: number;
  input?: any;
  onAdd: (itemName: string) => void;
  onRemove: (itemName: string) => void;
}

interface QuantityPanelState {}

class QuantityPanel extends PureComponent<
  QuantityPanelProps,
  QuantityPanelState
> {
  public render() {
    const { classes, t, quantity, price, input } = this.props;
    const isRemoveDisabled = !quantity || quantity < 1;
    const removeIconClass = isRemoveDisabled
      ? classes.removeIconDisabled
      : classes.removeIcon;
    const totalPrice = new Big(price).times(quantity || 0).toFixed(2);

    return (
      <Grid container className={classes.wrapper}>
        <Grid
          item
          container
          className={classes.contentWrapper}
          xs={6}
          justify="flex-start"
          alignItems="center"
        >
          <Typography className={classes.subtitle}>
            {t('QUANTITY_TITLE')}
          </Typography>
          <Grid className={classes.inputWrapper}>
            <IconButton
              disabled={isRemoveDisabled}
              className={classes.iconButton}
              onClick={this.handleRemoveClick}
            >
              <RemoveIcon className={removeIconClass} color="primary" />
            </IconButton>
            <QuantityFormField
              readOnly
              type="number"
              input={input}
              value={quantity}
            />
            <IconButton
              className={classes.iconButton}
              onClick={this.handleAddClick}
            >
              <AddIcon className={classes.icon} color="primary" />
            </IconButton>
          </Grid>
        </Grid>
        <Grid
          item
          container
          className={classes.contentWrapper}
          xs={6}
          justify="flex-end"
          alignItems="center"
        >
          <Typography className={classes.subtitle}>
            {t('TOTAL_PRICE')}
          </Typography>
          <Typography className={classes.title}>{totalPrice}</Typography>
        </Grid>
      </Grid>
    );
  }

  private handleRemoveClick = () => {
    const {
      onRemove,
      input: { name },
    } = this.props;
    onRemove(name);
  };

  private handleAddClick = () => {
    const {
      onAdd,
      input: { name },
    } = this.props;
    onAdd(name);
  };
}

export default withStyles(styles)(withTranslation()(QuantityPanel));
